import { MutationTree } from "vuex";
import { SettingsState, PrefType, Pref } from "./types";
import { getDefaultState } from "./state";

export const mutations: MutationTree<SettingsState> = {
	setAllPrefTypes(state, prefTypes: PrefType[]) {
		state.allPrefTypes = prefTypes;
	},
	setAllIcons(state, icons: any[]) {
		state.allIcons = icons;
	},
	setAllGroups(state, groups: any[]) {
		state.allGroups = groups;
	},
	setAllPrefs(state, prefs: Pref[]) {
		state.allPrefs = prefs;
	},
	setSelectedGroup(state, group) {
		state.selectedGroup = group;
	},
	resetState(state) {
		Object.assign(state, getDefaultState());
	},
	mergePrefs(state, prefsToMerge: Pref[]) {
		if (prefsToMerge !== undefined) {
			if (prefsToMerge.length > 0) {
				state.allPrefs = state.allPrefs
					.filter(originalPref => {
						return !prefsToMerge.some(newItem =>
							(
								newItem.groupID == originalPref.groupID &&
								newItem.prefTypeID == originalPref.prefTypeID
							) ||
							newItem.prefID == originalPref.prefID
						);
					})
					.concat(prefsToMerge);
			}
		}
	}
};
